module.exports = __webpack_public_path__ + "img/img13.ac339e9e.png";